import ConsentDXA from './ConsentDXA.md';
import ConsentRMR from './ConsentRMR.md';
import ConsentVO2 from './ConsentVO2.md';
import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import './Consent.css';


const agreements = {
  DXA: ConsentDXA,
  RMR: ConsentRMR,
  VO2: ConsentVO2,
};

function Consent({test}) {
  return (
    <ReactMarkdown className='Consent' source={agreements[test]} />
  );
}

Consent.propTypes = {
  test: PropTypes.string.isRequired,
};

export default Consent;



// WEBPACK FOOTER //
// ./src/components/Intake/Custom/Consent.js